import * as React from "react";
import { ListViewCard } from "../ListViewCard";
import type { ListViewCardAction, ListViewCardLayout } from "../ListViewCard";

export interface RewardChipCardItem {
  id: string;
  /** Display label (role's label/name, or permission's name). */
  title: string;
  /** Raw name/slug, shown as the subtitle. */
  slug: string;
  kind: "role" | "permission";
}

export interface RewardChipCardProps {
  layout: ListViewCardLayout;
  item: RewardChipCardItem;
  contextActions?: ListViewCardAction[];
  onClick?: () => void;
}

export function RewardChipCard({ layout, item, contextActions, onClick }: RewardChipCardProps) {
  return (
    <ListViewCard
      id={item.id}
      layout={layout}
      imageFormat="none"
      title={item.title}
      subtitle={item.slug}
      badges={[
        {
          id: "kind",
          label: item.kind === "role" ? "Role" : "Permission",
          variant: item.kind === "role" ? "active" : "default",
        },
      ]}
      onClick={onClick}
      contextActions={contextActions}
    />
  );
}
